import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import CRECUI from "crec-ui";
import "crec-ui/dist/crecui.css";
import "./assets/styles/tool.css";
import * as custom from "@/utils/filter.js";

// 引入全局混入
import globalMixin from "./mixins/global";
import "vant/lib/index.css";
import "./assets/iconfont/iconfont.css"; // 扩展图标
import "./assets/icons"; // icon

import { Button } from "vant";
import { Icon } from "vant";
import { DropdownMenu, DropdownItem } from "vant";
import { Popup } from "vant";
import { Tab, Tabs } from "vant";

import { Cell, CellGroup } from "vant";

// 默认语言为 en-US，此处设置中文
import moment from "moment";
moment.locale("zh-cn");

import { DateUtil } from "./utils/base/DateUtil";
Vue.prototype.parseTime = DateUtil.format;

Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Icon);
Vue.use(Button);
Vue.use(Popup);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(CRECUI);
Vue.mixin(globalMixin);

// main.js，注意要在use方法之后执行
// import uView from "uview-ui";
// Vue.use(uView);

// import uView from "uview-ui";

// Vue.use(uView);

//  注册全局过滤器
Object.keys(custom).forEach((key) => {
  Vue.filter(key, custom[key]);
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// // 初始化设备检测
// store.dispatch("device/initDeviceDetector");
